module.exports = __webpack_public_path__ + "img/05-mayo-banner-02.cf6e03b6.jpg";